export default __webpack_public_path__ + "static/media/profileImg.83718cc1.jpg";